module.exports = "a {\n  color: #09afdf !important; }\n"